import { AppSidebar } from "./AppSidebar";
import { Footer } from "./Footer";
import { ProtectedRoute } from "../auth/ProtectedRoute";
import { SidebarProvider } from "../ui/sidebar";

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

export const ProtectedLayout = ({ children }: ProtectedLayoutProps) => (
  <ProtectedRoute>
    <SidebarProvider>
      <div className="min-h-screen flex">
        <AppSidebar />
        <div className="flex-1 flex flex-col">
          <main className="flex-1 w-full">
            {children}
          </main>
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  </ProtectedRoute>
);